export function isNotNull<T>(element: T | null): element is T {
  return element !== null;
}
